// Themes
import theme from '@/themes/index';

const defaultProps = {
  src: '',
  width: 600,
  height: 450,
};

const Photo = ({
  src, 
  imgStyle = {
    objectFit: 'cover',
  },
}) => (
  <>
    <img src={src.url} style={imgStyle} />
    <style jsx>{`
      img {
        width: 100%;
        height: 100%;
      }

      @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
        img {
          height: 100%;
        }
      }
    `}</style>
  </>
);

Photo.defaultProps = defaultProps;

export default Photo;
